<div class="simulation-details">
  <ng-container *ngIf="tradeSimulation !== null && entityName !== null && !dataError">
    <app-new-derivative-collateral-modal [mode]="modelPopupMode.view" [tradeSimulation]="tradeSimulation" [legalEntityName]="entityName"></app-new-derivative-collateral-modal>
  </ng-container>
  <ng-container *ngIf="dataError">
    <div>
      <div class="modal-header">
        <h4 class="modal-title">View model: {{modelID}}</h4>
        <span class="logo-btn-small close white" (click)="activeModal.dismiss('Cross click')"></span>
      </div>
      <div class="modal-body d-flex flex-column">
        <div class="d-flex flex-row  justify-content-center align-items-center my-auto">
            <div class="px-p-15"><em class="material-icons md-65 color-gray">error_outline</em></div>
            <div class="px-p-10">
                <div class="px-px-10 color-bnpp-error fs-15px">{{dataError}}</div>
                <!-- <div class="color-bnpp-error px-p-10 fs-14px">{{notificationPopupMode.question}}</div> -->
            </div>
        </div>
      </div>

      <div class="modal-footer mt-auto">
        <button type="button" class="btn btn-sm btn-basic btn_style" (click)="activeModal.close('cancel')">CANCEL</button>
      </div>
    </div>
  </ng-container>
</div>
